import React, { useState, useEffect, useRef } from 'react';
import FeatherIcon from 'feather-icons-react';
import { Modal, Form, Row, Col, message, Select, Spin } from 'antd';
import PropTypes from 'prop-types';
import { AddUser } from '../style';
import { FetchAllCampaignByCreatedBy, CampaignUpdate, CampaignDetails } from '../../../Api/Services/CampaignApiServices';
import { BasicFormWrapper } from '../../styled';
import { Button } from '../../../components/buttons/buttons';
import { CampaignIcon } from '../../../components/Icons/Icons';

const { Option } = Select;

// pageFrom: "modal" (default, listing page) | "inline" (query page)
const Popup = ({ sharePopup, setSharePopup, sharingType, sharingIds, PageTypes, setStates, onSuccess, pageFrom, PreviousButton }) => {
    const [form] = Form.useForm();
    const loadingRef = useRef(false);
    const [deleteClick, setDelteClick] = useState(false)
    const [exportData, setExportData] = useState([])
    const [display, setDisplay] = useState(false)
    const [uiReady, setUiReady] = useState(false)

    async function getAllCampaigns() {
        try {
            const response = await FetchAllCampaignByCreatedBy()
            const options = response.map((option) => (
                <Option value={option.campaignId} key={option.campaignId} label={(
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        <div className='Div_flex2'>
                            <div className='share_image' title={`${option.campaignName} (${option.campaignStatus})`} style={{ cursor: "default" }}>
                                <span className="image_icon">
                                    {option.campaignName.slice(0, 1).toUpperCase()}
                                </span>
                                <span className='div-ellipsis'>{option.campaignName}</span>
                            </div>
                        </div>
                    </div>)}>
                    <div className='UserList-dropdown' title={`${option.campaignName} (${option.campaignStatus})`}>
                        <div>
                            <span className='details_span_Tag' style={{ width: '35px', height: '35px', borderRadius: 20, fontSize: 14 }}>
                                {option.campaignName.slice(0, 1).toUpperCase()}
                            </span>
                        </div>
                        <div>
                            <p style={{ fontWeight: 'bold', margin: 0 }}>{option.campaignName}</p>
                            <p style={{ margin: 0 }}>{option.campaignStatus}</p>
                        </div>
                    </div>
                </Option>
            ));
            setExportData(options)
        } catch (err) {
            setExportData([])
            message.error(err);
        }
    }

    const handleClose = () => {
        setSharePopup(false);
        if (PageTypes === "Multiple") {
            setStates({
                selectedRows: [],
                selectedRowKeys: [],
            })
        }
    }

    async function getCampaignData(id) {
        try {
            const response = await CampaignDetails(id);
            return response.data;
        } catch (error) {
            message.error(error);
        }
    }

    function updateCampaignIds(campaign, newIds, type) {
        const field = type === 'Lead' ? 'leads' : 'contacts';
        const existingIds = campaign[field]
            ? campaign[field].split(',').map(id => parseInt(id.trim())).filter(Boolean)
            : [];
        const updatedIds = Array.from(new Set([...existingIds, ...newIds]));
        return { [field]: updatedIds.join(',') };
    }

    const onSubmit = async (values) => {
        if (loadingRef.current) return;
        loadingRef.current = true;
        setDelteClick(true)
        setDisplay(true)
        let hideMessage;
        const { campaignName } = values;
        const CampainData = await getCampaignData(campaignName)
        const formData = updateCampaignIds(CampainData, sharingIds, sharingType)
        try {
            hideMessage = message.loading("Loading...", 0);
            const response = await CampaignUpdate(formData, campaignName)
            if (response.status === 200) {
                message.success(`Selected ${sharingType === "Contact" ? 'contacts' : 'leads'} have been successfully added to the campaign`)
                hideMessage();
                setDisplay(false)
                loadingRef.current = false;
                setDelteClick(false)
                if (pageFrom === "inline") {
                    // query page: notify parent to handle success state
                    if (onSuccess) onSuccess();
                } else {
                    // listing page: close modal + reset row selection
                    setSharePopup(false);
                    if (PageTypes === "Multiple") {
                        setStates({
                            selectedRows: [],
                            selectedRowKeys: [],
                        })
                    }
                }
            }
        } catch (error) {
            loadingRef.current = false;
            setDelteClick(false)
            if (hideMessage) hideMessage();
            setDisplay(false)
            message.error(error)
        }
    }

    const onFinishFailed = () => {
        message.error("Please fill out all required fields")
    }

    const fetchAll = async () => {
        await Promise.allSettled([getAllCampaigns()])
        setUiReady(true)
    };

    useEffect(() => {
        fetchAll()
    }, [])

    const campaignSelect = (
        <Select
            style={{ width: '100%' }}
            placeholder="Select campaign"
            showSearch
            optionLabelProp="label"
            optionFilterProp="children"
            filterOption={(input, option) => {
                const usernameElement = option.children.props.children[1].props.children[0];
                if (usernameElement && usernameElement.props && usernameElement.props.children) {
                    return String(usernameElement.props.children).toLowerCase().includes(input.toLowerCase());
                }
                return false;
            }}
        >
            {exportData}
        </Select>
    );

    // Inline mode — rendered inside LeadQueryPage "Perform Action" step
    if (pageFrom === "inline") {
        return (
            <AddUser style={{ width: "100%" }}>
                <div className="user-info-form">
                    <BasicFormWrapper>
                        {uiReady ? (
                            <Form style={{ width: '100%' }} form={form} name="CampaignInline" onFinish={onSubmit} onFinishFailed={onFinishFailed} colon={false}>
                                <div style={{ textAlign: "center", fontSize: "larger", fontWeight: "700" }}>Add to Campaign</div>
                                <Row gutter={30} style={{ marginBottom: 20, marginTop: 20 }}>
                                    <Col span={4} />
                                    <Col span={16}>
                                        <Form.Item name="campaignName" rules={[{ required: true, message: 'Please select a campaign' }]}>
                                            {campaignSelect}
                                        </Form.Item>
                                    </Col>
                                    <Col span={4} />
                                </Row>
                                <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", margin: "50px 25px 0px" }}>
                                    <Button size="small" className="gray-button" onClick={() => PreviousButton()}>
                                        <FeatherIcon icon="arrow-left" size={16} />Previous
                                    </Button>
                                    <Button htmlType="submit" className='btn-add_new button_colors' loading={deleteClick} disabled={deleteClick}>
                                        {!deleteClick && <CampaignIcon />}Add to Campaign
                                    </Button>
                                </div>
                            </Form>
                        ) : (
                            <div style={{ height: "300px" }} className="spin"><Spin /></div>
                        )}
                    </BasicFormWrapper>
                </div>
            </AddUser>
        );
    }

    // Modal mode — used from listing pages
    return (
        <>
            <Modal
                title="Add to Campaign"
                open={sharePopup}
                width={400}
                onCancel={handleClose}
                maskClosable={false}
                footer={uiReady ? [
                    <div key="footer">
                        <Button htmlType="submit" className="gray-button" size="small" onClick={handleClose} disabled={display}>
                            <FeatherIcon icon="x" /> Cancel
                        </Button>
                        <Button size="small" htmlType="submit" className="button_colors" onClick={() => form.submit()} loading={deleteClick} disabled={deleteClick}>
                            {!deleteClick && <CampaignIcon />}Add
                        </Button>
                    </div>
                ] : false}
            >
                {uiReady ? (
                    <AddUser>
                        <div className="user-info-form">
                            <BasicFormWrapper>
                                <Form style={{ width: '100%' }} form={form} name="CampaignModal" onFinish={onSubmit} onFinishFailed={onFinishFailed} colon={false}>
                                    <Row gutter={30} style={{ padding: "0px 20px" }}>
                                        <Col span={24} style={{ margin: "10px 0px" }}>
                                            <Form.Item name="campaignName" id="campaignName" rules={[{ required: true, message: 'Please enter campaign' }]}>
                                                {campaignSelect}
                                            </Form.Item>
                                        </Col>
                                    </Row>
                                </Form>
                            </BasicFormWrapper>
                        </div>
                    </AddUser>
                ) : (
                    <div style={{ height: "500px" }} className="spin"><Spin /></div>
                )}
            </Modal>
        </>
    );
};

Popup.propTypes = {
    sharePopup: PropTypes.bool,
    setSharePopup: PropTypes.func,
    sharingType: PropTypes.string.isRequired,
    sharingIds: PropTypes.array.isRequired,
    PageTypes: PropTypes.string,
    setStates: PropTypes.func,
    onSuccess: PropTypes.func,
    pageFrom: PropTypes.string,       // "modal" (default) | "inline"
    PreviousButton: PropTypes.func,   // required when pageFrom="inline"
};

Popup.defaultProps = {
    pageFrom: "modal",
};

export default Popup;
